import { render, staticRenderFns } from "./SearchQuotes.vue?vue&type=template&id=e9d4dacc&scoped=true"
import script from "./SearchQuotes.vue?vue&type=script&lang=js"
export * from "./SearchQuotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9d4dacc",
  null
  
)

export default component.exports